import { render, staticRenderFns } from "./ProductEdit.vue?vue&type=template&id=1b6e805e&scoped=true"
import script from "./ProductEdit.vue?vue&type=script&lang=ts"
export * from "./ProductEdit.vue?vue&type=script&lang=ts"
import style0 from "./ProductEdit.vue?vue&type=style&index=0&id=1b6e805e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6e805e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b6e805e')) {
      api.createRecord('1b6e805e', component.options)
    } else {
      api.reload('1b6e805e', component.options)
    }
    module.hot.accept("./ProductEdit.vue?vue&type=template&id=1b6e805e&scoped=true", function () {
      api.rerender('1b6e805e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEdit.vue"
export default component.exports